<template>
  <div>
    <b-alert
      variant="danger"
      v-if="productDetail && productDetail.reject_reason"
      show
    >
      <div class="alert-body">
        <span>{{ productDetail.reject_reason }}</span>
        <div class="italic" v-if="productDetail.reject_date">
          {{ moment(productDetail.reject_date).format('DD/MM/YYYY') }}
        </div>
      </div>
    </b-alert>
    <b-card class="product-add-wrapper">
      <b-form-group class="cs-checkbox">
        <b-form-checkbox
          v-model="isRequestToVerify"
          :disabled="
            productDetail &&
            productDetail.id &&
            productDetail.status > PRODUCT_ON_HODO.UNAVAILABLE
          "
          >{{ $t('lbl_request_to_verify') }}</b-form-checkbox
        >
      </b-form-group>
      <b-tabs pills>
        <b-tab active>
          <template #title>
            <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t('lbl_product_info') }}</span>
          </template>
          <div class="mt-2 pt-75" :class="{ disable: isDisableEdit }">
            <validation-observer ref="addProductValidation">
              <!-- form -->
              <b-form>
                <b-row>
                  <b-col cols="12" md="4" xxl="3" order-md="last">
                    <b-media
                      no-body
                      vertical-align="center"
                      class="flex-column mb-2"
                    >
                      <b-media-body class="w-100">
                        <div
                          class="preview-image border rounded mb-1"
                          @click="triggerChoosePreviewImage"
                        >
                          <div
                            v-if="previewImg"
                            v-b-tooltip="{
                              title: $t('lbl_remove_image'),
                              placement: 'bottom',
                              variant: 'danger'
                            }"
                            class="preview-image__clear d-flex flex-column position-absolute"
                            @click.stop="removeImage"
                          >
                            <feather-icon
                              class="m-auto"
                              size="16"
                              icon="XIcon"
                            />
                          </div>
                          <b-img
                            class="preview-image__item w-100 rounded"
                            v-show="previewImg"
                            :src="previewImg"
                            @error="(e) => appUtils.onHandleErrorLoadImage(e)"
                          />
                          <div
                            class="preview-image__item cursor-pointer w-100"
                            v-show="!previewImg"
                          >
                            <div class="m-auto text-center">
                              <feather-icon size="32" icon="ImageIcon" />
                              <div class="text-center mt-1">
                                {{ $t('lbl_feature_image') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-wrap thumbs-image"
                          style="margin: 0 -4px"
                        >
                          <div
                            class="thumbs-image__item"
                            v-for="(thumb, index) in thumbsImg"
                            :key="`thumb_${index}`"
                            style="padding: 0 4px"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative d-flex cursor-pointer"
                            >
                              <b-img
                                class="w-100 border rounded"
                                :src="thumb.url"
                              />
                              <div
                                class="thumbs-image__clear"
                                @click="removeThumbImg(index)"
                              >
                                <feather-icon
                                  class="m-auto"
                                  size="16"
                                  icon="XIcon"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="thumbs-image__item d-flex"
                            style="padding: 0 4px"
                            @click="triggerChooseThumbImage"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative border rounded d-flex flex-grow w-100 cursor-pointer"
                            >
                              <feather-icon
                                class="m-auto"
                                size="20"
                                icon="PlusIcon"
                              />
                            </div>
                          </div>
                        </div>
                        <small class="text-muted">{{
                          $t('lbl_required_image_resolution')
                        }}</small>
                        <input
                          hidden
                          ref="refInputEl"
                          type="file"
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectPreviewImage"
                        />
                        <input
                          hidden
                          ref="refInputThumbEl"
                          type="file"
                          multiple
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectThumbsImage"
                        />
                      </b-media-body>
                    </b-media>
                    <!-- <b-form-group label="Brand" class="mb-2">
                    <validation-provider #default="{ errors }" name="Brand" rules="required">
                      <b-form-input v-model="form.brand" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    </b-form-group>-->
                  </b-col>
                  <b-col cols="12" md="8" xxl="9" order-md="first">
                    <b-row>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_product_name')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_product_name')"
                            rules="required"
                          >
                            <b-form-input
                              v-model="form.name"
                              @update="generateSlug"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_product_name__english_')"
                          class="mb-2"
                        >
                          <b-form-input
                            v-model="form.product_multilanguage[0].name"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_brand')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_brand')"
                            rules="required"
                          >
                            <v-select
                              id="brand-product"
                              v-model="brandSelected"
                              label="name"
                              value="id"
                              :clearable="false"
                              :options="brandsOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">{{
                                $t('lbl_no_option')
                              }}</template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_manufacture')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_manufacture')"
                          >
                            <b-form-input v-model="form.manufacturer" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_manufacture__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_manufacture__english_')"
                          >
                            <b-form-input
                              v-model="
                                form.product_multilanguage[0].manufacturer
                              "
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_origin')" class="mb-2">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_origin')"
                          >
                            <b-form-input v-model="form.origin" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_origin__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_origin__english_')"
                          >
                            <b-form-input
                              v-model="form.product_multilanguage[0].origin"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group :label="$t('SKU')" class="mb-2 required">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('SKU')"
                            rules="required"
                          >
                            <b-form-input v-model="form.sku" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_slug')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_slug')"
                            rules="required"
                          >
                            <b-input-group :prepend="`${domain}products/`">
                              <b-form-input v-model="form.slug" />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-primary"
                                  @click="generateSlug"
                                  >{{ $t('lbl_generate') }}</b-button
                                >
                              </b-input-group-append>
                            </b-input-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_summary')" class="mb-2">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_summary')"
                          >
                            <b-form-textarea
                              v-model="form.short_desc"
                              rows="3"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_summary__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_summary__english_')"
                          >
                            <b-form-textarea
                              v-model="form.product_multilanguage[0].short_desc"
                              rows="3"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_description')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_description')"
                          >
                            <quill-editor
                              v-model="form.description"
                              :options="optionsEditor"
                              :disabled="isDisableEdit"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          :label="$t('lbl_description__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_description__english_')"
                          >
                            <quill-editor
                              v-model="
                                form.product_multilanguage[0].description
                              "
                              :options="optionsEditor"
                              :disabled="isDisableEdit"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-card bg-variant="light">
                          <b-row
                            v-for="(item, index) in form.product_variants"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                          >
                            <b-col
                              cols="12"
                              md="3"
                              class="px-50"
                              v-if="item.isSaleSelected"
                            >
                              <b-form-group
                                :label="$t('lbl_old_price')"
                                class="required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-old-price-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_old_price')"
                                  rules="required"
                                >
                                  <b-input-group append="VNĐ">
                                    <cleave
                                      v-model="item.old_price"
                                      class="form-control"
                                      :id="`input-old-price-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      :options="cleaveOptions.number"
                                      placeholder="10,000"
                                    />
                                  </b-input-group>
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              :md="item.isSaleSelected ? 3 : 4"
                              class="px-50"
                            >
                              <b-form-group
                                :label="$t('lbl_price_service')"
                                class="required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-price-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_price_service')"
                                  rules="required"
                                >
                                  <b-input-group append="VNĐ">
                                    <cleave
                                      v-model="item.price"
                                      class="form-control"
                                      :id="`input-price-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      :options="cleaveOptions.number"
                                      placeholder="10,000"
                                      @input="
                                        (value) =>
                                          handleSetPriceUnit(value, index)
                                      "
                                    />
                                  </b-input-group>
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              :md="item.isSaleSelected ? 3 : 4"
                              class="px-50"
                            >
                              <b-form-group
                                :label="$t('lbl_units')"
                                class="w-100 required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`select-unit-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_units')"
                                  rules="required"
                                >
                                  <v-select
                                    class="bg-white"
                                    v-model="item.unit"
                                    :label="
                                      currLanguage == 'en' ? 'name_en' : 'name'
                                    "
                                    value="id"
                                    append-to-body
                                    taggable
                                    :id="`select-unit-${
                                      item.id || item.code || index
                                    }`"
                                    :clearable="false"
                                    :options="unitsOption"
                                    :calculate-position="withPopper"
                                    @input="
                                      (value) => handleSelectUnit(value, index)
                                    "
                                  >
                                    <template slot="no-options">{{
                                      $t('lbl_no_option')
                                    }}</template>
                                  </v-select>
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              :md="item.isSaleSelected ? 3 : 4"
                              class="px-50"
                            >
                              <div class="d-flex">
                                <!-- <b-form-group :label="$t('lbl_units')" class="required">
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('lbl_units')"
                                  rules="required"
                                >
                                  <b-input-group>
                                    <cleave
                                      v-model="item.number_unit"
                                      class="form-control"
                                      :raw="false"
                                      :options="cleaveOptions.number"
                                      placeholder="10"
                                      @input="(value) => handleSetUnitNumber(value, index)"
                                    />
                                  </b-input-group>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                </b-form-group>-->
                                <div
                                  class="text-nowrap ml-1"
                                  style="margin-top: 27.42px"
                                >
                                  <b-button
                                    v-if="form.product_variants.length > 1"
                                    v-b-tooltip.hover
                                    :title="$t('lbl_remove')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="p-50"
                                    @click="
                                      removeItem(
                                        index,
                                        form.product_variants,
                                        handleRemoveVariant(item.id)
                                      )
                                    "
                                  >
                                    <feather-icon size="22" icon="Trash2Icon" />
                                    <span class="sr-only">{{
                                      $t('lbl_remove')
                                    }}</span>
                                  </b-button>
                                  <b-button
                                    v-if="
                                      index === form.product_variants.length - 1
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_add_new')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-primary"
                                    class="p-50 ml-50"
                                    @click="
                                      addNewUnitItem(form.product_variants)
                                    "
                                  >
                                    <feather-icon size="22" icon="PlusIcon" />
                                    <span class="sr-only">{{
                                      $t('lbl_add_new')
                                    }}</span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                            <!-- <b-col cols="12" class="px-50">
                              <b-form-group class="mb-0">
                                <validation-provider #default="{ errors }" name="On Sale">
                                  <b-form-checkbox v-model="item.isSaleSelected">On Sale</b-form-checkbox>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>-->
                            <b-col
                              cols="12"
                              class="px-50"
                              v-if="form.product_variants.length > 1"
                            >
                              <b-form-group class="mb-0">
                                <b-form-radio
                                  v-model="form.default_price"
                                  name="unit-radios"
                                  :value="item.price"
                                  @change="
                                    (value) =>
                                      handleSetDefaultPriceUnit(value, index)
                                  "
                                  >{{ $t('lbl_default_price') }}</b-form-radio
                                >
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              v-if="
                                index !== form.product_variants.length - 1 &&
                                form.product_variants.length > 1
                              "
                            >
                              <hr />
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-col>
                      <b-col
                        cols="12"
                        v-if="form.type === PRODUCT_TYPES.SERVICE"
                      >
                        <b-card bg-variant="light">
                          <div
                            class="font-weight-bold h4"
                            style="margin-left: -6px"
                          >
                            {{ $t('lbl_other_costs') }}
                          </div>
                          <b-row
                            v-for="(item, index) in form.other_expenses"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                          >
                            <b-col cols="12" :md="6" class="px-50">
                              <b-form-group :label="$t('lbl_cost_name')">
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('lbl_cost_name')"
                                >
                                  <b-form-input v-model="item.name" />
                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" :md="6" class="px-50">
                              <div class="d-flex">
                                <b-form-group :label="$t('lbl_cost')">
                                  <validation-provider
                                    #default="{ errors }"
                                    :vid="`input-expense-${
                                      item.id || item.code || index
                                    }`"
                                    :name="$t('lbl_cost')"
                                  >
                                    <b-input-group append="VNĐ">
                                      <cleave
                                        v-model="item.value"
                                        class="form-control"
                                        :id="`input-expense-${
                                          item.id || item.code || index
                                        }`"
                                        :raw="false"
                                        :options="cleaveOptions.number"
                                        placeholder="10,000"
                                      />
                                    </b-input-group>
                                    <small class="text-danger">{{
                                      errors[0]
                                    }}</small>
                                  </validation-provider>
                                </b-form-group>
                                <div
                                  class="text-nowrap ml-1"
                                  style="margin-top: 27.42px"
                                >
                                  <b-button
                                    v-if="form.other_expenses.length > 1"
                                    v-b-tooltip.hover
                                    :title="$t('lbl_remove')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="p-50"
                                    @click="
                                      removeItem(index, form.other_expenses)
                                    "
                                  >
                                    <feather-icon size="22" icon="Trash2Icon" />
                                    <span class="sr-only">{{
                                      $t('lbl_remove')
                                    }}</span>
                                  </b-button>
                                  <b-button
                                    v-if="
                                      index === form.other_expenses.length - 1
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_add_new')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-primary"
                                    class="p-50 ml-50"
                                    @click="
                                      addNewExpenseItem(form.other_expenses)
                                    "
                                  >
                                    <feather-icon size="22" icon="PlusIcon" />
                                    <span class="sr-only">{{
                                      $t('lbl_add_new')
                                    }}</span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                            <b-col
                              cols="12"
                              v-if="
                                index !== form.other_expenses.length - 1 &&
                                form.other_expenses.length > 1
                              "
                            >
                              <hr />
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_category')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_category')"
                            rules="required"
                          >
                            <v-select
                              id="category-product"
                              v-model="categorySelected"
                              :label="currLanguage == 'en' ? 'name_en' : 'name'"
                              value="id"
                              :clearable="false"
                              :options="categoriesOption"
                              :calculate-position="withPopper"
                            >
                              <template slot="no-options">{{
                                $t('lbl_no_option')
                              }}</template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group>
                          <b-form-checkbox v-model="isRequiredAttachment">{{
                            $t('lbl_require_attachment')
                          }}</b-form-checkbox>
                        </b-form-group>
                        <b-form-group
                          v-if="isRequiredAttachment"
                          :label="`${$t('lbl_required_attachment_configs')}:`"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Attachment"
                            :rules="isRequiredAttachment ? 'required' : ''"
                          >
                            <v-select
                              id="attachment-config"
                              v-model="attachmentConfigSelected"
                              label="title"
                              value="id"
                              :clearable="false"
                              :options="attachmentConfigs"
                              :calculate-position="withPopper"
                              @input="handleAttachmentSetDefaultData"
                            >
                              <template slot="no-options">{{
                                $t('lbl_no_option')
                              }}</template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="
                            attachmentConfigSelected &&
                            attachmentConfigSelected.id === -1
                          "
                          :label="$t('lbl_title_name_attachment_config')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_title_name_attachment_config')"
                            rules="required"
                          >
                            <b-form-input v-model="attachMentTitleConfig" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-card
                          v-if="
                            attachmentConfigSelected &&
                            attachmentConfigSelected.order_form_items
                          "
                          bg-variant="light"
                          class="cs-card"
                        >
                          <!-- <h4 class="mb-2">{{ $t('lbl_require_attachment') }}</h4> -->
                          <b-row
                            v-for="(
                              item, index
                            ) in attachmentConfigSelected.order_form_items"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                            ref="row"
                          >
                            <!-- Item Name -->
                            <b-col md="8">
                              <b-form-group class="mb-md-0">
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_deliverable_documents_title')"
                                  rules="required"
                                >
                                  <b-form-input
                                    v-if="isDisabledAttachmentConfigs"
                                    type="text"
                                    v-model="item.name"
                                    :vid="`input-${
                                      item.id || item.code || index
                                    }`"
                                    :placeholder="
                                      $t('lbl_eg__config_handout_documents')
                                    "
                                    :disabled="isDisabledAttachmentConfigs"
                                  />
                                  <b-row v-else>
                                    <b-col>
                                      <b-form-input
                                        type="text"
                                        v-model="item.name"
                                        :placeholder="
                                          $t('lbl_eg__config_handout_documents')
                                        "
                                      />
                                    </b-col>
                                    <b-col>
                                      <b-form-file
                                        v-model="item.file"
                                        :state="Boolean(item.file)"
                                        placeholder="Chọn hoặc thả file vào đây"
                                        drop-placeholder="Drop file here..."
                                      ></b-form-file>
                                    </b-col>
                                  </b-row>

                                  <small class="text-danger">{{
                                    errors[0]
                                  }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <!-- Buttons -->
                            <b-col md="4">
                              <!-- <div class="d-none d-md-block pb-2 mb-50"></div> -->
                              <div>
                                <b-button
                                  v-b-tooltip.hover
                                  v-if="
                                    attachementItems.length > 1 &&
                                    !isDisabledAttachmentConfigs
                                  "
                                  :title="$t('lbl_remove')"
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="px-1 py-50 mr-75"
                                  @click="removeItem(index, attachementItems)"
                                >
                                  <feather-icon size="22" icon="Trash2Icon" />
                                  <span class="sr-only">{{
                                    $t('lbl_remove')
                                  }}</span>
                                </b-button>
                                <b-button
                                  v-if="
                                    index === attachementItems.length - 1 &&
                                    !isDisabledAttachmentConfigs
                                  "
                                  v-b-tooltip.hover
                                  :title="$t('lbl_add_new')"
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-primary"
                                  class="px-1 py-50"
                                  @click="addNewDeliverable(attachementItems)"
                                >
                                  <feather-icon size="22" icon="PlusIcon" />
                                  <span class="sr-only">{{
                                    $t('lbl_add_new')
                                  }}</span>
                                </b-button>
                              </div>
                            </b-col>
                            <b-col
                              cols="12"
                              v-if="
                                index !== attachementItems.length - 1 &&
                                attachementItems.length > 1
                              "
                            >
                              <hr />
                            </b-col>
                          </b-row>
                        </b-card>
                        <b-form-group
                          :label="$t('lbl_product_type')"
                          v-slot="{ ariaDescribedby }"
                        >
                          <b-form-radio-group
                            v-model="form.type"
                            :aria-describedby="ariaDescribedby"
                            name="product-type-radios"
                            @change="handleChangeType"
                          >
                            <b-form-radio :value="PRODUCT_TYPES.PRODUCT">{{
                              $t(Object.keys(PRODUCT_TYPES)[0])
                            }}</b-form-radio>
                            <b-form-radio :value="PRODUCT_TYPES.SERVICE">{{
                              $t(Object.keys(PRODUCT_TYPES)[1])
                            }}</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                        <div>
                          <b-form-group
                            :label="$t('lbl_delivery_progress')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_delivery_progress')"
                              rules="required"
                            >
                              <v-select
                                id="category-product-delivery-status"
                                v-model="deliveryStatusSelected"
                                :label="
                                  currLanguage == 'en' ? 'title_en' : 'title'
                                "
                                value="id"
                                :clearable="false"
                                :options="deliveryStatusOptions"
                                :calculate-position="withPopper"
                                @input="handleSetDefaultData"
                              >
                                <template slot="no-options">{{
                                  $t('lbl_no_option')
                                }}</template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-form-group
                            v-if="
                              deliveryStatusSelected &&
                              deliveryStatusSelected.id === -1
                            "
                            :label="$t('lbl_title_name_status_config')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_title_name_status_config')"
                              rules="required"
                            >
                              <b-form-input v-model="statusTitleConfig" />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-card
                            bg-variant="light"
                            v-if="
                              deliveryStatusSelected !== null ||
                              deliveryDefinitionSelected !== null
                            "
                          >
                            <div
                              class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2"
                            >
                              <h4 class="mb-md-0">
                                {{ $t('lbl_service_deliverables') }}
                              </h4>
                              <div v-if="false">
                                <b-button
                                  class="mr-50"
                                  v-b-tooltip.hover
                                  :title="$t('lbl_set_default_data')"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="outline-primary"
                                  size="sm"
                                  @click="handleSetDefaultData"
                                >
                                  <feather-icon icon="PlusCircleIcon" />
                                  <span class="ml-50 sr-only">{{
                                    $t('lbl_set_default_data')
                                  }}</span>
                                </b-button>
                                <b-button
                                  v-b-tooltip.hover
                                  :title="$t('lbl_reset_data')"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="outline-danger"
                                  size="sm"
                                  @click="handleReset"
                                >
                                  <feather-icon icon="RefreshCwIcon" />
                                  <span class="ml-50 sr-only">{{
                                    $t('lbl_reset_data')
                                  }}</span>
                                </b-button>
                              </div>
                            </div>

                            <!-- Add deliverable status -->
                            <div>
                              <h5
                                class="border-left-primary pl-50"
                                style="border-left-width: 4px"
                              >
                                {{
                                  $t(
                                    'lbl_delivery_status_notification_check_list'
                                  )
                                }}
                              </h5>
                              <b-card-text>{{
                                $t(
                                  'lbl_this_will_be_shown_to_your_customer_how_they_should_await_for_package_delivery'
                                )
                              }}</b-card-text>
                              <b-row
                                v-for="(item, index) in deliverableStatus"
                                :id="item.id || item.code || index"
                                :key="item.id || item.code || index"
                                ref="row"
                              >
                                <!-- Item Name -->
                                <b-col md="8">
                                  <b-form-group
                                    :label="`${$t('lbl_step')} ${
                                      index + 1 < 10
                                        ? `0${index + 1}`
                                        : index + 1
                                    }`"
                                    class="mb-md-0"
                                  >
                                    <validation-provider
                                      #default="{ errors }"
                                      :vid="`input-${
                                        item.id || item.code || index
                                      }`"
                                      :name="
                                        $t('lbl_title_name_deliverable_status')
                                      "
                                      rules="required"
                                    >
                                      <b-form-input
                                        type="text"
                                        :value="
                                          currLanguage == 'en'
                                            ? getTitleStatusEn(
                                                item.delivery_state_step_multilanguage
                                              )
                                            : item.title
                                        "
                                        :id="`input-${
                                          item.id || item.code || index
                                        }`"
                                        :placeholder="
                                          $t(
                                            'lbl_ex__receiver_order__processing__sending____'
                                          )
                                        "
                                        :disabled="isDisabledDeliverableStates"
                                      />
                                      <small class="text-danger">{{
                                        errors[0]
                                      }}</small>
                                    </validation-provider>
                                  </b-form-group>
                                </b-col>

                                <!-- Buttons -->
                                <b-col md="4">
                                  <div
                                    class="d-none d-md-block pb-2 mb-50"
                                  ></div>
                                  <div>
                                    <b-button
                                      v-b-tooltip.hover
                                      v-if="
                                        deliverableStatus.length > 1 &&
                                        !isDisabledDeliverableStates
                                      "
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="px-1 py-50 mr-75"
                                      @click="
                                        removeItem(index, deliverableStatus)
                                      "
                                    >
                                      <feather-icon
                                        size="22"
                                        icon="Trash2Icon"
                                      />
                                      <span class="sr-only">{{
                                        $t('lbl_remove')
                                      }}</span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index ===
                                          deliverableStatus.length - 1 &&
                                        !isDisabledDeliverableStates
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="px-1 py-50"
                                      @click="
                                        addNewDeliverable(deliverableStatus)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">{{
                                        $t('lbl_add_new')
                                      }}</span>
                                    </b-button>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="12"
                                  v-if="
                                    index !== deliverableStatus.length - 1 &&
                                    deliverableStatus.length > 1
                                  "
                                >
                                  <hr />
                                </b-col>
                              </b-row>
                            </div>
                          </b-card>
                        </div>
                        <div v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-form-group
                            :label="$t('lbl_delivery_definition')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_delivery_definition')"
                              rules="required"
                            >
                              <v-select
                                id="category-product-definition"
                                v-model="deliveryDefinitionSelected"
                                :label="
                                  currLanguage == 'en' ? 'title_en' : 'title'
                                "
                                value="id"
                                :clearable="false"
                                :options="deliveryDefinitionOptions"
                                :calculate-position="withPopper"
                                @input="handleSetDefinitionData"
                              >
                                <template slot="no-options">{{
                                  $t('lbl_no_option')
                                }}</template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-form-group
                            v-if="
                              deliveryDefinitionSelected &&
                              deliveryDefinitionSelected.id === -1
                            "
                            :label="$t('lbl_title_name_definition_config')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_title_name_definition_config')"
                              rules="required"
                            >
                              <b-form-input v-model="definitionTitleConfig" />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-card
                            bg-variant="light"
                            v-if="deliveryDefinitionSelected !== null"
                          >
                            <div
                              class="mb-2"
                              v-if="form.type === PRODUCT_TYPES.SERVICE"
                            >
                              <h5
                                class="border-left-primary pl-50"
                                style="border-left-width: 4px"
                              >
                                {{ $t('lbl_deliverable_definition') }}
                              </h5>
                              <b-card-text>{{
                                $t('lbl_will_be_automatically_sent_to_customer')
                              }}</b-card-text>
                              <b-row
                                v-for="(item, index) in deliverableDocs"
                                :id="item.id || item.code || index"
                                :key="item.id || item.code || index"
                                ref="row"
                              >
                                <!-- Item Name -->
                                <b-col md="8">
                                  <b-form-group class="mb-md-0">
                                    <validation-provider
                                      #default="{ errors }"
                                      :vid="`input-${
                                        item.id || item.code || index
                                      }`"
                                      :name="
                                        $t('lbl_deliverable_documents_title')
                                      "
                                      rules="required"
                                    >
                                      <b-form-input
                                        type="text"
                                        :value="
                                          currLanguage == 'en'
                                            ? getTitleAttachmentEn(
                                                item.attachment_item_multilangs
                                              )
                                            : item.title
                                        "
                                        :id="`input-${
                                          item.id || item.code || index
                                        }`"
                                        :placeholder="
                                          $t(
                                            'lbl_eg__consultation__test_results____'
                                          )
                                        "
                                        :disabled="isDisabledDeliverableDocs"
                                      />
                                      <small class="text-danger">{{
                                        errors[0]
                                      }}</small>
                                    </validation-provider>
                                  </b-form-group>
                                </b-col>

                                <!-- Buttons -->
                                <b-col md="4">
                                  <!-- <div class="d-none d-md-block pb-2 mb-50"></div> -->
                                  <div>
                                    <b-button
                                      v-b-tooltip.hover
                                      v-if="
                                        deliverableDocs.length > 1 &&
                                        !isDisabledDeliverableDocs
                                      "
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="px-1 py-50 mr-75"
                                      @click="
                                        removeItem(index, deliverableDocs)
                                      "
                                    >
                                      <feather-icon
                                        size="22"
                                        icon="Trash2Icon"
                                      />
                                      <span class="sr-only">{{
                                        $t('lbl_remove')
                                      }}</span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index === deliverableDocs.length - 1 &&
                                        !isDisabledDeliverableDocs
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="px-1 py-50"
                                      @click="
                                        addNewDeliverable(deliverableDocs)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">{{
                                        $t('lbl_add_new')
                                      }}</span>
                                    </b-button>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="12"
                                  v-if="
                                    index !== deliverableDocs.length - 1 &&
                                    deliverableDocs.length > 1
                                  "
                                >
                                  <hr />
                                </b-col>
                              </b-row>
                            </div>
                            <!-- Add deliverable stauts -->
                          </b-card>
                        </div>
                        <div v-if="formRegisterProfile.length">
                          <div class="mb-1">
                            {{ $t('lbl_test_register_profile') }}
                          </div>
                          <b-card bg-variant="light">
                            <h5
                              class="border-left-primary pl-50"
                              style="border-left-width: 4px"
                            >
                              {{ $t('lbl_list_of_test_register_profile') }}
                            </h5>
                            <b-card-text>{{
                              $t(
                                'lbl_this_list_will_be_displayed_in_the_service_s_test_registration_profile'
                              )
                            }}</b-card-text>
                            <div class="d-flex flex-column" style="gap: 12px">
                              <div
                                class="cursor-pointer"
                                v-for="(
                                  registerItem, index
                                ) in formRegisterProfile"
                                :key="index"
                              >
                                <div v-if="registerItem && registerItem.child">
                                  <div class="bg-white p-1 w-100">
                                    <div
                                      class="d-flex align-items-center w-100"
                                      style="gap: 8px"
                                    >
                                      <input
                                        @change="
                                          (e) =>
                                            handleCollapseRegisterProfile(
                                              e,
                                              registerItem
                                            )
                                        "
                                        style="width: 16px; height: 16px"
                                        type="checkbox"
                                        class="cursor-pointer"
                                        v-model="registerItem.checked"
                                      />
                                      <div
                                        v-b-toggle="'collapse-register'"
                                        style="flex: 1; gap: 16px"
                                        class="bg-white rounded d-flex justify-content-between"
                                      >
                                        <div class="font-weight-bold">
                                          {{ registerItem.form_name }}
                                        </div>
                                        <div
                                          @click.stop="
                                            checkRequireAll(registerItem)
                                          "
                                          class="d-flex justify-content-between align-items-center"
                                          style="gap: 6px; margin-bottom: 4px"
                                        >
                                          <input
                                            v-if="registerItem.checked"
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="registerItem.isRequired"
                                          />
                                          <span
                                            v-if="registerItem.checked"
                                            class="text-danger font-italic"
                                            style="font-size: 14px"
                                            >{{ $t('lbl_required') }}</span
                                          >
                                          <br />
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="when-open"
                                          >
                                            <path
                                              d="M8.99991 3.58594L7.58569 5.00015L14.5857 12.0002L7.58569 19.0002L8.99991 20.4144L17.4141 12.0001L8.99991 3.58594Z"
                                              fill="#515151"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <b-collapse visible id="collapse-register">
                                      <div
                                        v-for="(
                                          formItem, index
                                        ) in registerItem.child"
                                        :key="`formItem-${index}`"
                                        class="d-flex align-items-center w-100 p-1 mt-1"
                                        style="
                                          background-color: #f6f6f6;
                                          gap: 8px;
                                        "
                                      >
                                        <div
                                          style="flex: 1; gap: 16px"
                                          class="rounded d-flex"
                                          @click="
                                            handleChangeFormRegisterProfile(
                                              formItem
                                            )
                                          "
                                        >
                                          <input
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="formItem.checked"
                                          />
                                          <div
                                            class="font-weight-bold"
                                            style="flex: 1"
                                          >
                                            {{ formItem.form_name }}
                                          </div>
                                        </div>
                                        <div
                                          v-if="formItem.checked"
                                          @click="
                                            () =>
                                              (formItem.isRequired =
                                                !formItem.isRequired)
                                          "
                                          class="d-flex justify-content-between align-items-center"
                                          style="gap: 6px; margin-bottom: 4px"
                                        >
                                          <input
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="formItem.isRequired"
                                          />
                                          <span
                                            class="text-danger font-italic"
                                            style="font-size: 14px"
                                            >{{ $t('lbl_required') }}</span
                                          >
                                          <br />
                                        </div>
                                      </div>
                                    </b-collapse>
                                  </div>
                                </div>
                                <div
                                  v-else
                                  class="d-flex flex-column align-items-center"
                                >
                                  <div
                                    v-if="registerItem"
                                    class="d-flex align-items-center w-100"
                                    style="gap: 8px"
                                  >
                                    <div
                                      style="gap: 16px; flex: 1"
                                      class="bg-white p-1 rounded d-flex"
                                    >
                                      <input
                                        class="cursor-pointer"
                                        style="width: 16px; height: 16px"
                                        type="checkbox"
                                        v-model="registerItem.checked"
                                      />
                                      <div
                                        style="flex: 1"
                                        @click="
                                          handleChangeFormRegisterProfile(
                                            registerItem
                                          )
                                        "
                                        class="font-weight-bold"
                                      >
                                        {{ registerItem.form_name }}
                                      </div>
                                      <div
                                        v-if="registerItem.checked"
                                        @click.self="
                                          () =>
                                            (registerItem.isRequired =
                                              !registerItem.isRequired)
                                        "
                                        class="d-flex justify-content-between align-items-center"
                                        style="gap: 6px; margin-bottom: 4px"
                                      >
                                        <input
                                          class="cursor-pointer"
                                          style="width: 16px; height: 16px"
                                          type="checkbox"
                                          v-model="registerItem.isRequired"
                                        />
                                        <span
                                          class="text-danger font-italic"
                                          style="font-size: 14px"
                                          >{{ $t('lbl_required') }}</span
                                        >
                                        <br />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <!-- attachment config -->

                <!-- <b-card
                bg-variant="light"
                v-if="deliveryStatusSelected !== null || deliveryDefinitionSelected !== null"
              >
                <div
                  class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2"
                >
                  <h4 class="mb-md-0">{{ $t('lbl_service_deliverables') }}</h4>
                  <div v-if="false">
                    <b-button
                      class="mr-50"
                      v-b-tooltip.hover
                      :title="$t('lbl_set_default_data')"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      size="sm"
                      @click="handleSetDefaultData"
                    >
                      <feather-icon icon="PlusCircleIcon" />
                      <span class="ml-50 sr-only">{{ $t('lbl_set_default_data') }}</span>
                    </b-button>
                    <b-button
                      v-b-tooltip.hover
                      :title="$t('lbl_reset_data')"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-danger"
                      size="sm"
                      @click="handleReset"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                      <span class="ml-50 sr-only">{{ $t('lbl_reset_data') }}</span>
                    </b-button>
                  </div>
                </div>
                <div class="mb-2" v-if="form.type===PRODUCT_TYPES.SERVICE">
                  <h5
                    class="border-left-primary pl-50"
                    style="border-left-width: 4px;"
                  >{{ $t('lbl_deliverable_definition') }}</h5>
                  <b-card-text>{{ $t('lbl_will_be_automatically_sent_to_customer') }}</b-card-text>
                  <b-row
                    v-for="(item, index) in deliverableDocs"
                    :id="item.id || item.code || index"
                    :key="item.id || item.code || index"
                    ref="row"
                  >
                    <b-col md="8">
                      <b-form-group class="mb-md-0">
                        <validation-provider
                          #default="{ errors }"
                          :vid="`input-${item.id || item.code || index}`"
                          :name="$t('lbl_deliverable_documents_title')"
                          rules="required"
                        >
                          <b-form-input
                            type="text"
                            v-model="item.title"
                            :id="`input-${item.id || item.code || index}`"
                            :placeholder="$t('lbl_eg__consultation__test_results____')"
                            :disabled="isDisabledDeliverableDocs"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <div>
                        <b-button
                          v-b-tooltip.hover
                          v-if="deliverableDocs.length > 1 && !isDisabledDeliverableDocs"
                          :title="$t('lbl_remove')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="px-1 py-50 mr-75"
                          @click="removeItem(index, deliverableDocs)"
                        >
                          <feather-icon size="22" icon="Trash2Icon" />
                          <span class="sr-only">{{ $t('lbl_remove') }}</span>
                        </b-button>
                        <b-button
                          v-if="index === deliverableDocs.length - 1 && !isDisabledDeliverableDocs"
                          v-b-tooltip.hover
                          :title="$t('lbl_add_new')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-primary"
                          class="px-1 py-50"
                          @click="addNewDeliverable(deliverableDocs)"
                        >
                          <feather-icon size="22" icon="PlusIcon" />
                          <span class="sr-only">{{ $t('lbl_add_new') }}</span>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      v-if="index !== deliverableDocs.length - 1 && deliverableDocs.length > 1"
                    >
                      <hr />
                    </b-col>
                  </b-row>
                </div>

                <div>
                  <h5
                    class="border-left-primary pl-50"
                    style="border-left-width: 4px;"
                  >{{ $t('lbl_delivery_status_notification_check_list') }}</h5>
                  <b-card-text>{{ $t('lbl_this_will_be_shown_to_your_customer_how_they_should_await_for_package_delivery') }}</b-card-text>
                  <b-row
                    v-for="(item, index) in deliverableStatus"
                    :id="item.id || item.code || index"
                    :key="item.id || item.code || index"
                    ref="row"
                  >
                    <b-col md="8">
                      <b-form-group
                        :label="`${$t('lbl_step')} ${index + 1 < 10 ? `0${index+1}` : index + 1}`"
                        class="mb-md-0"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :vid="`input-${item.id || item.code || index}`"
                          :name="$t('lbl_title_name_deliverable_status')"
                          rules="required"
                        >
                          <b-form-input
                            type="text"
                            v-model="item.title"
                            :id="`input-${item.id || item.code || index}`"
                            :placeholder="$t('lbl_ex__receiver_order__processing__sending____')"
                            :disabled="isDisabledDeliverableStates"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <div class="d-none d-md-block pb-2 mb-50"></div>
                      <div>
                        <b-button
                          v-b-tooltip.hover
                          v-if="deliverableStatus.length > 1 && !isDisabledDeliverableStates"
                          :title="$t('lbl_remove')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="px-1 py-50 mr-75"
                          @click="removeItem(index, deliverableStatus)"
                        >
                          <feather-icon size="22" icon="Trash2Icon" />
                          <span class="sr-only">{{ $t('lbl_remove') }}</span>
                        </b-button>
                        <b-button
                          v-if="index === deliverableStatus.length - 1 && !isDisabledDeliverableStates"
                          v-b-tooltip.hover
                          :title="$t('lbl_add_new')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-primary"
                          class="px-1 py-50"
                          @click="addNewDeliverable(deliverableStatus)"
                        >
                          <feather-icon size="22" icon="PlusIcon" />
                          <span class="sr-only">{{ $t('lbl_add_new') }}</span>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      v-if="index !== deliverableStatus.length - 1 && deliverableStatus.length > 1"
                    >
                      <hr />
                    </b-col>
                  </b-row>
                </div>
                </b-card>-->
              </b-form>
              <!--/ form -->
            </validation-observer>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="FileTextIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t('lbl_certificates') }}</span>
            <!-- <feather-icon
            v-b-tooltip="{ title: 'You must select the category first', placement: 'top' }"
            icon="HelpCircleIcon"
            size="16"
            class="mr-0 ml-sm-50"
            />-->
          </template>
          <product-certificates
            :is_changed_category="is_changed_category"
            :categorySelected="categorySelected"
            :certificatesData="certificatesData"
            @setCertificates="setCertificates"
            @refresh="fetchProductCertificates"
            :productDetail="productDetail"
            class="mt-2 pt-75"
            :disable="isDisableEdit"
            :class="{ disable: isDisableEdit }"
          />
        </b-tab>
      </b-tabs>
      <b-row v-if="!isDisableEdit">
        <b-col cols="12">
          <b-button
            v-if="productId"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isLoading"
            @click="updateProduct"
            >{{ $t('lbl_update_product') }}</b-button
          >
          <b-button
            v-else
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isLoading"
            @click="addProduct"
            >{{ $t('lbl_add_new') }}</b-button
          >
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            :to="{ name: 'products' }"
            variant="outline-secondary"
            >{{ $t('lbl_cancel') }}</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import useAddProduct from './useAddProduct'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.vi'
import { createPopper } from '@popperjs/core'
import ProductCertificates from './Certificates.vue'
import appUtils from '@/utils/appUtils'
import { PRODUCT_ON_HODO, PRODUCT_TYPES } from '@/utils/constant'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'AddAndUpdateProduct',
  components: {
    vSelect,
    Cleave,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    ProductCertificates
  },
  directives: {
    Ripple
  },
  setup() {
    const mixData = useAddProduct()
    return { ...mixData }
  },
  data() {
    return {
      required,
      cleaveOptions: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand'
        }
      },
      nextTodoId: 1,
      placement: 'bottom',
      PRODUCT_TYPES,
      appUtils,
      isDisabledDeliverableDocs: true,
      isDisabledDeliverableStates: true,
      isDisabledAttachmentConfigs: true,
      PRODUCT_ON_HODO,
      currLanguage: this.$store.state.language.currLanguage
    }
  },
  async created() {
    const slug = this.$route.params?.slug
    const id = slug?.split('-')?.slice(-1)

    this.productId = (id && id[0]) || null
    this.fetchCategoriesList()
    this.fetchUnitsList()
    this.fetchBrandsList()
    this.fetchDeliveryStatusConfigsList()
    this.fetchDeliveryDefinitionConfigsList()
    await this.handleGetConsentForm()

    this.productId &&
      this.fetchProductById().then(() => {
        this.handleSetDefaultData(this.deliveryStatusSelected)
        this.handleSetDefinitionData(this.deliveryDefinitionSelected)
        this.fetchProductCertificates()
      })
  },

  computed: {
    ...mapGetters('app', ['lanCodeOptions', 'statusOptions']),
    isDisableEdit() {
      return this.productDetail?.status === this.PRODUCT_ON_HODO.AVAILABLE
    }
  },
  mounted() {
    const userData = appUtils.getLocalUser()

    if (!userData?.supplierInfo?.id) return
    this.getAttachmentConfigs(userData?.supplierInfo?.id)
  },
  methods: {
    checkRequireAll(registerItem) {
      registerItem.isRequired = !registerItem.isRequired
      registerItem.child.forEach((child) => {
        child.isRequired = registerItem.isRequired
      })
    },
    triggerChoosePreviewImage() {
      this.$refs.refInputEl.click()
    },
    triggerChooseThumbImage() {
      this.$refs.refInputThumbEl.click()
    },
    removeImage() {
      this.$refs.refInputEl.value = null
      this.form.primary_image = null
      this.previewImg = null
    },
    removeThumbImg(index) {
      this.form.thumbnail_image && this.form.thumbnail_image?.splice(index, 1)
      this.form.thumb_images && this.form.thumb_images?.splice(index, 1)
      this.thumbsImg && this.thumbsImg.splice(index, 1)
    },
    addNewUnitItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        price: null,
        unit: {}
      })
    },
    addNewExpenseItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        name: '',
        value: null,
        unit: 'VNĐ'
      })
    },
    addNewDeliverable(data) {
      data.push({
        code: appUtils.randomCode(10),
        title: ''
      })
    },
    removeItem(index, data, callback) {
      data.splice(index, 1)

      if (callback instanceof Function) {
        callback()
      }
    },
    handleRemoveVariant(variant_id) {
      if (isNaN(variant_id)) return

      this.$rf.getRequest('CommonRequest').deleteVariant(variant_id)
    },
    handleSelectUnit(option, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        unit_id: option.id,
        package_name: option.value,
        unit: {
          ...option,
          name_en: option.product_unit_multilanguages?.find(
            (elm) => elm.language == 'en'
          )?.name
        }
      }
    },
    handleSetPriceUnit(value, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        price: Number(value?.toString()?.replaceAll(',', '')) || 0
      }
    },
    handleSetUnitNumber(value, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        number_unit: Number(value?.toString()?.replaceAll(',', '')) || 0
      }
      console.log()
    },
    handleSetDefaultPriceUnit(value, index) {
      this.form.default_price = this.form.product_variants[index]?.price
      this.form.default_unit_name =
        this.form.product_variants[index]?.unit?.name
      this.form.default_number_unit =
        this.form.product_variants[index]?.number_unit

      console.log(this.form)
    },
    handleSetDefaultData(option) {
      this.deliverableStatus = (option?.delivery_state_steps?.length && [
        ...option?.delivery_state_steps
      ]) || [...this.initialDeliverables.deliverableStatus]

      if (!option?.delivery_state_steps?.length) {
        this.isDisabledDeliverableStates = false
      } else {
        this.isDisabledDeliverableStates = true
      }
    },
    handleAttachmentSetDefaultData(option) {
      this.attachementItems = (option?.order_form_items?.length && [
        ...option?.order_form_items
      ]) || [...this.initialDeliverables.attachementItems]

      if (!option?.order_form_items?.length) {
        this.isDisabledAttachmentConfigs = false
      } else {
        this.isDisabledAttachmentConfigs = true
      }
    },
    handleSetDefinitionData(option) {
      this.deliverableDocs = (option?.attachment_items?.length && [
        ...option?.attachment_items
      ]) || [...this.initialDeliverables.deliverableDocs]

      if (!option?.attachment_items?.length) {
        this.isDisabledDeliverableDocs = false
      } else {
        this.isDisabledDeliverableDocs = true
      }
    },
    handleReset() {
      this.deliverableDocs = [...this.initialDeliverables.deliverableDocs]
      this.deliverableStatus = [...this.initialDeliverables.deliverableStatus]
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    },
    setCertificates(value) {
      this.certificates = (value.length && [...value]) || []
    },
    handleChangeFormRegisterProfile(item) {
      if (item.checked) {
        item.checked = false
        item.isRequired = false
      } else {
        item.checked = true
      }
    },
    handleCollapseRegisterProfile(e, data) {
      data.checked = e.target.checked
      data?.child.forEach((item) => {
        item.checked = e.target.checked
      })
    },
    getTitleAttachmentEn(arr) {
      return (
        arr?.find((elm) => elm.language == 'en')?.title || 'Attachment config'
      )
    },
    getTitleStatusEn(arr) {
      return arr?.find((elm) => elm.language == 'en')?.title || 'Status config'
    }
  },
  watch: {
    '$store.state.language.currLanguage': function () {
      this.currLanguage = this.$store.state.language.currLanguage
    }
  }
}
</script>

<style lang="scss" scoped>
.disable {
  cursor: not-allowed;
  pointer-events: none;
  .form-control,
  .v-select,
  .input-group-text,
  .thumbs-image__item-wrap,
  .quill-editor {
    background-color: #f6f6f6 !important;
    cursor: not-allowed;
    pointer-events: none;
  }
  .input-group-append,
  .btn {
    opacity: 60%;
  }
}
.preview-image {
  position: relative;
  width: 100%;

  &::before {
    content: '';
    display: block;
    padding-top: percentage(720/1200);
    transition: all 0.3s ease;
    border-radius: 4px;
  }

  &:hover::before {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &__item {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__clear {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 32px;
    height: 32px;
    border-radius: 4px 0 4px 0;
    line-height: 1;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 4px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.9);
    }
  }
}
.thumbs-image {
  &__item {
    position: relative;
    width: 25%;
    height: 52px;
    transition: all 0.3s ease;

    // &:not(:last-child) {
    //   margin-right: 8px;
    // }

    &-wrap {
      height: 100%;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);

        .thumbs-image__clear {
          visibility: visible;
          opacity: 1;
        }
      }

      img {
        object-fit: cover;
      }
    }
  }

  &__clear {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: center;
    visibility: hidden;
    opacity: 0;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    transition: all 0.3s ease;
  }
}
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.cs-checkbox {
  position: absolute;
  top: 30px;
  right: 20px;
}

.cs-card .card-body {
  padding: 12px;
}

.not-collapsed > .when-open {
  transform: rotate(90deg);
}
</style>
